export default __webpack_public_path__ + "static/media/ASSEMBLY FIXTURE WITH POKA YOKE.a164dea7.png";